<Dialog :visible="show" :modal="true" @closeDialog="close" @update:visible="close" >
    <template #header>
        <h3>{{ header }}</h3>
    </template>

    <div>{{ content }}</div>

    <template #footer>
        <div class="dialogButtonsWrapper">
            <Button :label="actionLabel" @click="accept" icon="pi pi-check" class="p-button-text" />
        </div>
    </template>
</Dialog>
